import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Expertise } from 'src/app/shared/models/expertise';
import { GenreType, GenreTypeString } from 'src/app/shared/models/employee/genre-type';
import { TauxReconnaissance } from 'src/app/shared/models/tauxReconnaissance';
import { NiveauEtude } from 'src/app/shared/models/niveauEtude';
import { NiveauQualification } from 'src/app/shared/models/niveauQualification';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { EligibiliteBeneficiaire } from 'src/app/shared/models/eligibiliteBeneficiaire';
import { StatutProfessionnel } from 'src/app/shared/models/statutProfessionnel';
import { Amenagement } from 'src/app/shared/models/amenagement';
import { SituationFamiliale } from 'src/app/shared/models/situationFamiliale';
import { Editor } from 'ngx-editor';
import { BeneficiaireDiplome } from 'src/app/shared/models/beneficiareDiplome';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Router } from '@angular/router';
import { Region } from 'src/app/shared/models/region';
import { Departement } from 'src/app/shared/models/departement';

@Component({
	selector: 'app-beneficiaire-form',
	templateUrl: './beneficiaire-form.component.html',
	styleUrls: ['./beneficiaire-form.component.scss']
})
export class BeneficiaireFormComponent implements OnInit {
	/**
	 * Beneficiaire
	 */
	@Input() beneficiaire: Beneficiaire;

	/**
	 * Vrai si formulaire d'ajout, faux sinon (formulaire de détail)
	 */
	@Input() isAddForm: boolean;

	/**
	 * Addresse sélectionner dans le typeahead
	 */
	@Input() isAddressSelected: { value: boolean };

	/**
	 * Booleen indiquant si il s'agit de l'addresse par défaut ou non
	 */
	@Input() isAddressDefault: { value: boolean };

	/**
	 * Formulaire angular
	 */
	@Input() form: FormGroup;

	/**
	 * Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	 */
	@Input() isValidateButtonClicked: { value: boolean };

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	@Output() hideModal: EventEmitter<any> = new EventEmitter();

	@ViewChild("listExistBeneficiaire",{static:true}) content:TemplateRef<any>;

	LABEL_BENEFICIAIRE: string;
	LABEL_INTERVENANT: string;
	MAX_NAME_CHAR = 25;

	/**
	 * Addresse selectionner
	 */
	selectedaddress?: Address;

	/**
	 * Typeahead des adresse en chargement
	 */
	typeaheadLoading?: boolean;

	/**
	 * Liste des adresse disponibles dans le typeahead
	 */
	addressList: Observable<NominatimResponse[]>;

	/**
	 * Liste des adresse récupérer grace au backend
	 */
	searchResults: NominatimResponse[];

	isPreferencesActive = false;

	listExpertise: TypeHandicap[];
	listSelectedExpertise: TypeHandicap[];

	listDiplome: BeneficiaireDiplome[];

	selectedTauxReconnaissance: TauxReconnaissance;

	public GenreEnum = GenreType;
	public GenreTypeStringEnum = GenreTypeString;
	listOptionHandicapPrincipal: string[];
	listOptionModeCommunication: string[];
	listOptionDegreSurdite: string[];

	listTauxReconnaissance: TauxReconnaissance[];
	listNiveauEtude: NiveauEtude[];
	listNiveauQualification: NiveauQualification[];
	listEligibiliteBeneficiaire: EligibiliteBeneficiaire[];
	listStatutProfessionnel: StatutProfessionnel[];
	listRegion: Region[];
	listDepartement: Departement[];
	listHandicapDetail: Departement[];
	listAmenagement: Amenagement[];
	listSituationFamiliale: SituationFamiliale[];
	existBenefList: Beneficiaire[] = [];

	editorRapportHandicap: Editor;
	editorDoleances: Editor;
	editorOrigineHandicap: Editor;

	benefListModalRef: BsModalRef;
	isIntervenant: boolean;
	isHVSelected: boolean = false;

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private cache: CacheService,
		private router: Router,
		private modalService: BsModalService,
		private fb: FormBuilder
	) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.form.value.address);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
		if (this.beneficiaire) {
			this.editorRapportHandicap = new Editor();
			this.editorDoleances = new Editor();
			this.editorOrigineHandicap = new Editor();

			this.isIntervenant = this.facade.dataStorageService.isIntervenant();

			this.facade.typeHandicapService.getAllTypeHandicaps().subscribe({
				next: (val) => {
					this.listExpertise = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.tauxReconnaissanceService.getAllTauxReconnaissance().subscribe({
				next: (val) => {
					this.listTauxReconnaissance = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.niveauEtudeService.getAllNiveauEtude().subscribe({
				next: (val) => {
					this.listNiveauEtude = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.niveauQualificationService.getAllNiveauQualification().subscribe({
				next: (val) => {
					this.listNiveauQualification = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.statutProfessionnelService.getAllStatutProfessionnel().subscribe({
				next: (val) => {
					this.listStatutProfessionnel = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.eligibiliteBeneficiaireService.getAllEligibiliteBeneficiaire().subscribe({
				next: (val) => {
					this.listEligibiliteBeneficiaire = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.amenagementService.getAllAmenagement().subscribe({
				next: (val) => {
					this.listAmenagement = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.departementService.getAllDepartement().subscribe({
				next: (val) => {
					this.listDepartement = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.listRegion = this.facade.dataStorageService.getService()?.regions;

			// this.facade.situationFamilialeService.getAllSituationFamiliale().subscribe({
			// 	next: (val) => {
			// 		this.listSituationFamiliale = val;
			// 	},
			// 	error: (err) => {
			// 		this.logger.error(err);
			// 	}
			// });


			this.listSelectedExpertise = this.beneficiaire.typeHandicaps != null ? [...this.beneficiaire.typeHandicaps] : [];
			this.listDiplome = this.beneficiaire.diplomes != null ? [...this.beneficiaire.diplomes] : [];

			if(this.isAddForm){
				this.listSelectedExpertise.push(this.facade.dataStorageService.getService()?.typeHandicap);
			}
			
			this.listOptionHandicapPrincipal = [];
			this.listSelectedExpertise.forEach(e => {
			if(e.name.includes('visuel')){
				this.listOptionHandicapPrincipal.push('Basse vision')
				this.listOptionHandicapPrincipal.push('Cécité')
			}else if(e.name.includes('moteur')){
				this.listOptionHandicapPrincipal.push('Lombalgie')
				this.listOptionHandicapPrincipal.push('TMS')
				this.listOptionHandicapPrincipal.push('Rhumatisme')
				this.listOptionHandicapPrincipal.push('Malformation')
				this.listOptionHandicapPrincipal.push('Paralysie')
				this.listOptionHandicapPrincipal.push('AVC')
				this.listOptionHandicapPrincipal.push('Amputation')

				this.listOptionHandicapPrincipal.push('SEP')
				this.listOptionHandicapPrincipal.push('Fibromyalgie')
				this.listOptionHandicapPrincipal.push('Spondyarthrite ankylosante')
				this.listOptionHandicapPrincipal.push('Troubles cardiaques')
				this.listOptionHandicapPrincipal.push('Cancer')
				this.listOptionHandicapPrincipal.push('Maladie de Chrohn')
				this.listOptionHandicapPrincipal.push('Diabete')
				this.listOptionHandicapPrincipal.push('Autres')
			}else if(e.name.includes('TND')){
				this.listOptionHandicapPrincipal.push("Troubles cognitifs acquis (traumatisme crânien, avc...)")
				this.listOptionHandicapPrincipal.push("Troubles du déficit de l'attention avec ou sans hyperactivité")
				this.listOptionHandicapPrincipal.push("Troubles du développement intellectuel (dont handicap mental)")
				this.listOptionHandicapPrincipal.push("Troubles du spectre de l'autisme")
				this.listOptionHandicapPrincipal.push("Troubles spécifiques du langage et des apprentissages (DYS)")
				this.listOptionHandicapPrincipal.push("Epilepsie")
				this.listOptionHandicapPrincipal.push("Polyhandicap")
				}
			})

			this.listOptionModeCommunication = [];
			this.listOptionModeCommunication.push("Communication orale")
			this.listOptionModeCommunication.push("Codage LPC")
			this.listOptionModeCommunication.push("Langue des signes")

			this.listOptionDegreSurdite = [];
			this.listOptionDegreSurdite.push('Légère')
			this.listOptionDegreSurdite.push('Moyenne')
			this.listOptionDegreSurdite.push('Profonde')

			if(this.listSelectedExpertise.find(e => e.name.includes("auditif"))){
				this.isHVSelected = true;
			}

			this.address?.setValidators([
				// Validators.required,
				// Validators.maxLength(60),
				this.isAddressValidValidator()
			]);

			(this.form.get('diplomes') as FormArray).removeAt(0);

			if (!this.isAddForm) {
				if (this.beneficiaire.address && this.beneficiaire.address.label) {
					this.isAddressDefault.value = true;
				}
				
				for (let diplome of this.listDiplome) {
            
					let etablissement: FormControl = new FormControl('');
					let annee: FormControl = new FormControl('');
					let amenagement: FormControl = new FormControl('');
					let niveauEtude: FormControl = new FormControl('');
		
					etablissement.setValue(diplome.etablissement);
					annee.setValue(diplome.annee);
					amenagement.setValue(diplome.amenagement);
					niveauEtude.setValue(diplome.niveauEtude);
		
					(this.form.get('diplomes') as FormArray).push(new FormGroup({
						etablissement: etablissement,
						annee: annee,
						amenagement: amenagement,
						niveauEtude: niveauEtude
					}));
				}

				this.form.patchValue({
					firstName: this.beneficiaire.firstName,
					lastName: this.beneficiaire.lastName,
					address: this.beneficiaire.address?.label || '',
					birthDate: this.beneficiaire.birthDate !== null && this.beneficiaire.birthDate !== ''
					? new Date(this.beneficiaire.birthDate)
					: null,
					email: this.beneficiaire.email,
					telephone: this.beneficiaire.telephone,
					genre: this.beneficiaire.genre,
					typeHandicaps: this.beneficiaire.typeHandicaps,
					handicapPrincipal: this.beneficiaire.handicapPrincipal,
					modeCommunication: this.beneficiaire.modeCommunication,
					degreSurdite: this.beneficiaire.degreSurdite,
					tauxReconnaissance: this.beneficiaire.tauxReconnaissance?.id,
					niveauEtude: this.beneficiaire.niveauEtude?.id,
					niveauQualification: this.beneficiaire.niveauQualification?.id,
					//situationFamiliale: this.beneficiaire.situationFamiliale,
					origineHandicap: this.beneficiaire.origineHandicap,
					doleances: this.beneficiaire.doleances,
					rapportHandicap:this.beneficiaire.rapportHandicap,
					environnementSocial:this.beneficiaire.environnementSocial,
					//eligibiliteBeneficiaire:this.beneficiaire.eligibiliteBeneficiaire?.id,
					statutProfessionnel:this.beneficiaire.statutProfessionnel?.id,
					region:this.beneficiaire.region?.id,
				});

		}
		
		}
	}

	isExpertiseCheck(spec: Expertise): boolean {
		return this.listSelectedExpertise?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	updateSelectedExpertise(e: any, spe: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(z) => z.id !== spe.id
				);
			}
		}

		this.listOptionHandicapPrincipal = [];
		this.listSelectedExpertise.forEach(e => {
			if(e.name.includes('visuel')){
				this.listOptionHandicapPrincipal.push('Basse vision')
				this.listOptionHandicapPrincipal.push('Cécité')
			}else if(e.name.includes('moteur')){
				this.listOptionHandicapPrincipal.push('Lombalgie')
				this.listOptionHandicapPrincipal.push('TMS')
				this.listOptionHandicapPrincipal.push('Rhumatisme')
				this.listOptionHandicapPrincipal.push('Malformation')
				this.listOptionHandicapPrincipal.push('Paralysie')
				this.listOptionHandicapPrincipal.push('AVC')
				this.listOptionHandicapPrincipal.push('Amputation')

				this.listOptionHandicapPrincipal.push('SEP')
				this.listOptionHandicapPrincipal.push('Fibromyalgie')
				this.listOptionHandicapPrincipal.push('Spondyarthrite ankylosante')
				this.listOptionHandicapPrincipal.push('Troubles cardiaques')
				this.listOptionHandicapPrincipal.push('Cancer')
				this.listOptionHandicapPrincipal.push('Maladie de Chrohn')
				this.listOptionHandicapPrincipal.push('Diabete')
				this.listOptionHandicapPrincipal.push('Autres')
			}else if(e.name.includes('TND')){
				this.listOptionHandicapPrincipal.push("Troubles cognitifs acquis (traumatisme crânien, avc...)")
				this.listOptionHandicapPrincipal.push("Troubles du déficit de l'attention avec ou sans hyperactivité")
				this.listOptionHandicapPrincipal.push("Troubles du développement intellectuel (dont handicap mental)")
				this.listOptionHandicapPrincipal.push("Troubles du spectre de l'autisme")
				this.listOptionHandicapPrincipal.push("Troubles spécifiques du langage et des apprentissages (DYS)")
				this.listOptionHandicapPrincipal.push("Epilepsie")
				this.listOptionHandicapPrincipal.push("Polyhandicap")
			}
		})

		this.isHVSelected = false;
		if(this.listSelectedExpertise.find(e => e.name.includes("auditif"))){
			this.isHVSelected = true;
		}

	}

	getFullNameOfEmp(emp: Employee) {
		return emp.firstName + ' ' + emp.lastName;
	}

	/**
	 * Méthode appeler lors de la sélection d'un élément dans le typeahead
	 * @param event
	 */
	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.form.controls['address'].updateValueAndValidity();
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.log(
					'' + err.status + ' ' + err.error.message ? err.error.message : ''
				);
			}
		});
		return of(this.searchResults);
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	/**
	 * Fonction appelée si une adresse commence à être tapée.
	 */
	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress && this.selectedaddress.latitude != 0) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}else{
			this.selectedaddress = new Address();
			this.selectedaddress.label = e.value
			this.isAddressSelected.value = true;
		}
		this.form.controls['address'].updateValueAndValidity();
	}

	checkExistBeneficiaire(){
		let firstName = this.form.value.firstName;
		let lastName = this.form.value.lastName;
		let birthDate = new Date(new Date(this.form.get('birthDate').value).setHours(12,0,0,0)).toUTCString()

		if(firstName != null && lastName != null && birthDate != null){
			if(this.isAddForm){
				this.existBenefList = [];
				this.facade.beneficiaireService.getBeneficiaireByNameAndBirthDate(firstName, lastName, birthDate).subscribe({
					next: (val) => {
						if(val != null){
							this.existBenefList.push(val);
						}

						if(this.existBenefList?.length > 0){
							//this.modalService.hide();
							this.benefListModalRef = this.modalService.show(this.content,
								{
									class: 'modal-lg',
									backdrop: 'static'
								});
						}
					}
				})
			}
		}
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitForm() {
		if (this.form.valid) {
				this.beneficiaire.typeHandicaps = this.listSelectedExpertise;
				this.beneficiaire.genre = this.form.value.genre;
				this.beneficiaire.firstName = this.form.value.firstName;
				this.beneficiaire.lastName = this.form.value.lastName;
				if (this.isAddressSelected.value && this.selectedaddress !== null) {
					this.beneficiaire.address = this.selectedaddress;
				} else {
					if (!this.isAddressDefault.value) {
						this.beneficiaire.address.label = this.form.value.address;
					}
				}
				
				if(this.beneficiaire.address?.label != null){
					var codePostal;
					var pattern = new RegExp(/\b\d{5}\b/g);
					codePostal = this.beneficiaire.address.label.match(pattern);
					console.log(codePostal);
					this.listDepartement.forEach(dep => {
						if(dep.code == codePostal[0].substring(0,2)){
							this.beneficiaire.departement = dep;
						}
					});
				}
				this.beneficiaire.birthDate = new Date(new Date(this.form.get('birthDate').value).setHours(12,0,0,0)).toISOString();
				this.beneficiaire.telephone = this.form.get('telephone').value;
				this.beneficiaire.email = this.form.get('email').value;
				this.beneficiaire.handicapPrincipal = this.form.get('handicapPrincipal').value;
				this.beneficiaire.modeCommunication = this.form.get('modeCommunication').value;
				this.beneficiaire.degreSurdite = this.form.get('degreSurdite').value;
				this.beneficiaire.tauxReconnaissance = this.listTauxReconnaissance.find(x => x.id == this.form.get('tauxReconnaissance').value); 
				this.beneficiaire.niveauEtude = this.listNiveauEtude.find(x => x.id == this.form.get('niveauEtude').value); 
				this.beneficiaire.niveauQualification = this.listNiveauQualification.find(x => x.id == this.form.get('niveauQualification').value); 
				//this.beneficiaire.situationFamiliale = this.listSituationFamiliale.find(x => x.id == this.form.get('situationFamiliale').value); 
				//this.beneficiaire.origineHandicap = this.form.get('origineHandicap').value;
				//this.beneficiaire.doleances = this.form.get('doleances').value;
				//this.beneficiaire.rapportHandicap = this.form.get('rapportHandicap').value;
				this.beneficiaire.environnementSocial = this.form.get('environnementSocial').value;
				//this.beneficiaire.eligibiliteBeneficiaire = this.listEligibiliteBeneficiaire.find(x => x.id == this.form.get('eligibiliteBeneficiaire').value); 
				this.beneficiaire.statutProfessionnel = this.listStatutProfessionnel.find(x => x.id == this.form.get('statutProfessionnel').value); 
				if(!this.isIntervenant){
					this.beneficiaire.region = this.facade.dataStorageService.getRegion();
				}
				//this.beneficiaire.diplomes = this.form.value.diplomes;
				this.sendForm.emit();
		}
	}

	// get situationFamiliale() {
	// 	return this.form?.get('situationFamiliale');
	// }
	get origineHandicap() {
		return this.form?.get('origineHandicap');
	}
	get doleances() {
		return this.form?.get('doleances');
	}
	get rapportHandicap() {
		return this.form?.get('rapportHandicap');
	}
	get environnementSocial() {
		return this.form?.get('environnementSocial');
	}
	// get eligibiliteBeneficiaire() {
	// 	return this.form?.get('eligibiliteBeneficiaire');
	// }
	get statutProfessionnel() {
		return this.form?.get('statutProfessionnel');
	}
	get firstName() {
		return this.form?.get('firstName');
	}
	get lastName() {
		return this.form?.get('lastName');
	}
	get email() {
		return this.form.get('email');
	}
	get telephone() {
		return this.form.get('telephone');
	}
	get genre() {
		return this.form.get('genre');
	}
	get handicapPrincipal() {
		return this.form.get('handicapPrincipal');
	}
	get modeCommunication() {
		return this.form.get('modeCommunication');
	}
	get degreSurdite() {
		return this.form.get('degreSurdite');
	}
	get birthDate() {
		return this.form.get('birthDate');
	}
	get tauxReconnaissance() {
		return this.form.get('tauxReconnaissance');
	}
	get niveauEtude() {
		return this.form.get('niveauEtude');
	}
	get niveauQualification() {
		return this.form.get('niveauQualification');
	}
	get address() {
		return this.form?.get('address');
	}
	get expertises() {
		return this.form?.get('expertises');
	}
	get diplomesBeneficiaire() {
		return this.form.get('diplomes') as FormArray;
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

	onAddDiplome() {
		this.diplomesBeneficiaire.push(this.fb.group({
			etablissement: '',
			annee: '',
			amenagement: '',
			niveauEtude: ''
		}));
	}
	
	removeDiplome(index:number)
	{
		(this.form.get('diplomes') as FormArray).removeAt(index)
	}

	isExpertiseDisabled(defaultTypeHandicap: TypeHandicap): boolean {
		return this.facade.dataStorageService.getService()?.typeHandicap?.id==defaultTypeHandicap.id;
	}

	addBenefService(selectedBenef : Beneficiaire) : void{
		if(!selectedBenef.typeHandicaps?.includes(this.facade.dataStorageService.getService().typeHandicap)){
			selectedBenef.typeHandicaps?.push(this.facade.dataStorageService.getService().typeHandicap);
			if(this.facade.dataStorageService.getRegion() != selectedBenef.region){
				selectedBenef.regionAutre = this.facade.dataStorageService.getRegion();
			}
			this.facade.beneficiaireService
				.updateBeneficiaire(selectedBenef)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
					}
				});
		}
		this.modalService.hide();
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

}
